// extracted by mini-css-extract-plugin
module.exports = {"btnsWrap":"ResendRegisterMail_btnsWrap_Ao9T3"};